// React and Icons
import React from 'react'
import { MdOutlineAddCircleOutline } from 'react-icons/md'
import { IoArrowBackOutline } from 'react-icons/io5'

// Components
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import Joints from '../../components/Joints'

// Hooks and Utils
import useGoBack from '../../hooks/useGoBack'
import useUserStore from '../../utils/state/useUserStore'

const Joint = () => {
  const GoBack = useGoBack()
  const userPermissions = useUserStore((state) => state.user) || []
  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center justify-between w-full'>
          <div className='flex gap-2 items-center font-medium'>
            <h1 className='text-2xl'>Joint</h1>
          </div>
          {userPermissions.includes('joint:create') ? (
            <LinkButton
              icon={<MdOutlineAddCircleOutline className='text-xl' />}
              to={'/joint/add'}
              label={'Add Joint'}
            />
          ) : null}
        </div>
      </PageHeader>
      <Joints userPermissions={userPermissions} />
    </div>
  )
}

export default Joint
